import {Table} from '@components/commons/table/Table.tsx'
import {StyledTableWrapper} from '@/features/signup-requests/components/requests-status/style.ts'
import {columnsPendingTable} from '@/features/signup-requests/components/requests-status/pending/columnsPendingTable.tsx'
import {useTranslation} from 'react-i18next'
import {FC} from 'react'
import {RequestTypeWithStatus, SignUpRequestsProps} from '@/features/signup-requests/types.ts'
import {useActionSingleRequest} from '@/features/signup-requests/queries/useActionSingleRequest.ts'
import {Spinner} from '@components/ui/spinner/Spinner.tsx'

export const PendingRequests: FC<SignUpRequestsProps> = ({
    data,
    isLoading,
    sorter,
    isMobile,
    setSelectedIds,
    selectedIds
}) => {
    const {t} = useTranslation()
    const actionSingleRequest = useActionSingleRequest()

    const onSelect = (id: number) => {
        // Check if the ID is already selected
        const index = selectedIds.indexOf(id)
        if (index === -1) {
            // If not selected, add it to the array
            setSelectedIds([...selectedIds, id])
        } else {
            // If already selected, remove it from the array
            const updatedIds = [...selectedIds]
            updatedIds.splice(index, 1)
            setSelectedIds(updatedIds)
        }
    }

    const handleActionRequest = async (request: RequestTypeWithStatus) => {
        await actionSingleRequest.mutateAsync(request)
        setSelectedIds([])
    }

    return (
        <>
            {actionSingleRequest.isPending && <Spinner />}
            <StyledTableWrapper>
                <Table
                    isMobile={isMobile}
                    sorter={sorter}
                    columns={columnsPendingTable({
                        t,
                        onSelect,
                        selectedIds,
                        handleActionRequest,
                        isMobile
                    })}
                    data={data}
                    isLoading={isLoading}
                />
            </StyledTableWrapper>
        </>
    )
}
